import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { ResponseData } from "./types/_public";
import { IReportAgency, IReportInventory } from "./types/_report";
const api = new APIClient();

const path = '/reports';
const reportApi = {
  agencyReports(params: any = {}): Promise<AxiosResponse<ResponseData<IReportAgency>, any>> {
    const url = `${path}/agency`;
    return api.get(url, params)
  },
  inventoryReports(params: any = {}): Promise<AxiosResponse<ResponseData<IReportInventory>, any>> {
    const url = `${path}/inventory`;
    return api.get(url, params)
  },
}
export default reportApi;
